import { AuthState } from '@okta/okta-auth-js';

import { Views } from '../../services/backend/Views';
import { useBaseApiClient } from '../useBaseApiClient';

export const useViews: () => Views<AuthState> = () => {
  return useBaseApiClient(Views);
};
